'use strict';
angular.module('resCenDigitalPreviewDetailModule', []).controller('resCenDigitalPreviewDetailCtrl', [
    '$scope',
    '$state',
    '$stateParams',
    '$q',
    '$filter',
    '$timeout',
    '$interval',
    'trsHttpService',
    'initComDataService',
    'resourceCenterService',
    'resCtrModalService',
    'modalDialog',
    'trsspliceString',
    'dateFilter',
    'globleParamsSet',
    '$window',
    'storageListenerService',
    'trsPrintService',
    'ueditorService',
    '$rootScope',
    function(
        $scope,
        $state,
        $stateParams,
        $q,
        $filter,
        $timeout,
        $interval,
        trsHttpService,
        initComDataService,
        resourceCenterService,
        resCtrModalService,
        modalDialog,
        trsspliceString,
        dateFilter,
        globleParamsSet,
        $window,
        storageListenerService,
        trsPrintService,
        ueditorService,
        $rootScope
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态函数开始
         * @return {[type]} [description] null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: '1',
                PAGESIZE: 12,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.params = {
                bc: $stateParams.bc,
                // pageUrl: '',
                docpubtime: unescape($stateParams.docpubtime),
                mediaId: $stateParams.nodeid,
                typeid: 'zyzx',
                modelid: 'getBmDetail',
                serviceid: 'jtcpg', // $stateParams.serviceid
            };
            $scope.status = {
                currModule: 'szb',
                batchOperateBtn: {
                    hoverStatus: '',
                    clickStatus: '',
                },
                iwoEdit: {
                    1: 'iwonews',
                    2: 'iwoatlas',
                },
                newspaperEdit: {
                    1: 'newspapertext',
                    2: 'newspaperpic',
                },
                websiteEdit: {
                    1: 'websitenews',
                    2: 'websiteatlas',
                },
                isShowDetail: false,
                docPubtime: $filter('date')($scope.params.docpubtime, 'yyyy-MM-dd').toString(),
                docPubtimeCN: getDocPubTimeCn(),
                hasData: true,
                paperName: $stateParams.papername,
                downloadTime: '',
                isChangeTime: true, // 是否通过改变日期
                imgOverWidth: 1, // 图片宽、高度 缩放比例
            };
            var splitTime = $scope.status.docPubtime.split('/');
            $scope.status.downloadTime = splitTime[0] + splitTime[1] + splitTime[2].split(' ')[0];
            $scope.data = {
                items: [],
                space: '',
                headers: [],
                selectedArray: [],
                operFlags: [],
                detail: '',
                currItem: '',
                currIndex: '',
                pdfPath: '',
                dropDown: {
                    banciList: [],
                    selectedBanmian: {},
                },
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                    maxDate: globleParamsSet.dateFormat(new Date(), '-'),
                },
            };
            $scope.basicParams = {
                channelName: $scope.status.currModule,
                mediaId: $stateParams.nodeid,
            };
            // 初始化canvas
            initCanvas();
            // 监听日期变化
            listenDate();
            // 查询当前报纸是否有上一期和下一期
            findOtherTermsPubtime();
        }

        /**
         * [getDocPubTimeCn description] 获取中文日期
         * @return {[type]} [description]
         */
        function getDocPubTimeCn() {
            var dateCn = '';
            var day;
            var date = new Date(Date.parse(unescape($state.params.docpubtime)));
            dateCn += $filter('date')(date, 'yyyy年MM月dd日 ');
            day = date.getDay();
            switch (day) {
                case 1:
                    day = '星期一';
                    break;
                case 2:
                    day = '星期二';
                    break;
                case 3:
                    day = '星期三';
                    break;
                case 4:
                    day = '星期四';
                    break;
                case 5:
                    day = '星期五';
                    break;
                case 6:
                    day = '星期六';
                    break;
                case 0:
                    day = '星期日';
                    break;
            }
            return dateCn + day;
        }

        /**
         * [initStatus description]初始化请求数据函数开始
         * @return {[type]} [description] null
         */
        function initData() {
            headPortrait();
            requestBanciDropDown(unescape($stateParams.docpubtime)).then(function(data) {
                // $scope.params.pageUrl = data.content[0].IR_PAGEURL;
                $scope.params.bc = data.content[0][0].BC;
                $scope.data.imgUrl = data.content[0][0].JPPATH;
                $scope.data.banmianName = data.content[0][0].BM;
                $scope.data.pdfPath = truePDF(data.content[0]);
                requestData();
            });
        }

        /**
         * [requestData description]请求数据函数开始
         * @return {[type]} [description] null
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.data.selectedArray = [];

                /* if (data.content.length < 1 && $scope.status.isChangeTime) {
                        $scope.status.hasData = false;
                        $scope.data.banmianName = '所选日期没有报纸';
                        return;
                    } else {
                        $scope.status.hasData = true;
                    }*/
                $scope.data.items = data.content;
                // $scope.data.imgUrl = trueBanmianImg(data.content);
                // $scope.data.banmianName = data.content[0].BM;
                // $scope.data.pdfPath = truePDF(data.content);
                $scope.basicParams.indexName = data.summary_info.indexName;
                $scope.status.isShowDetail = false;
                $scope.data.detail = '';
                $scope.data.currItem = '';
                $('<img/>')
                    .attr('src', $scope.data.imgUrl)
                    .load(function() {
                        // var realWidth = this.width;
                        // var realHeight = this.height;
                        var realWidth = this.width;
                        var realHeight = this.height;
                        var aspectRatio = realWidth / realHeight;
                        var height = 300 / aspectRatio;
                        $('.left_Img').css({ width: 300 });
                        $('#Img_a_image').css({ width: 300, height: height });
                        $('#Img_a_canvas').css({ width: 300, height: height });
                        $('#Img_a').css({ width: 300, height: height });
                        $('#Img_a_canvas').attr({ width: 300, height: height });
                        init_area(realWidth, realHeight);
                    });
                initOperFlag();
            });
        }

        /**
         * [truePDF description] 找出PDF
         */
        function truePDF(list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].PDPATH) {
                    return list[i].PDPATH;
                }
            }
            return false;
        }

        /**
         * [requestBanciDropDown description] 请求版次下拉框
         */
        function requestBanciDropDown(date) {
            var defer = $q.defer();
            var banciParams = {
                serviceid: $scope.params.serviceid,
                mediaId: $scope.basicParams.mediaId,
                modelid: 'findBmMenu', // getBmMenu
                typeId: 'zyzx',
                docpubtime: date,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), banciParams, 'post').then(function(data) {
                if (data.result === 'fail') {
                    $scope.status.hasData = false;
                    return;
                }
                var banciList = data.content[0],
                    index = 0;
                angular.forEach(banciList, function(value, key) {
                    value.name = value.BC + '版： ' + value.BM;
                    if (value.BC == $scope.params.bc) {
                        index = key;
                    }
                });
                $scope.data.dropDown.banciList = banciList;
                $scope.data.dropDown.selectedBanmian = banciList[index];
                // 自动将滚动条移到顶部
                $('trs-single-select').one('click', function() {
                    $timeout(function() {
                        $('.dropdown-menu')
                            .eq(0)
                            .scrollTop(0);
                    });
                });
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [openUrl description] 打开链接
         */
        $scope.openUrl = function(url) {
            if (!url) {
                return;
            }
            window.open(url);
        };

        /**
         * [openUrl description] 打开链接
         */
        $scope.downloadUrl = function(url) {
            window.location.href = url;
        };

        /**
         * [searchBanmian description]选择版面
         */
        $scope.searchWithKeyword = function(banmian) {
            if ($scope.params.bc == banmian.BC) {
                return;
            }
            $scope.status.isChangeTime = false;
            $scope.params.bc = banmian.BC;
            $scope.data.imgUrl = banmian.JPPATH;
            $scope.data.pdfPath = banmian.PDPATH;
            $scope.data.banmianName = banmian.BM;
            requestData();
        };

        /**
         * [searchWidthList description]点版面列表搜索
         */
        $scope.searchWidthList = function(banmian) {

            /* if ($scope.params.pageUrl == banmian.IR_PAGEURL) return;
                $scope.params.pageUrl = banmian.IR_PAGEURL;*/
            $scope.status.isChangeTime = false;
            if ($scope.params.bc == banmian.BC) {
                return;
            }
            $scope.params.bc = banmian.BC;
            $scope.data.dropDown.selectedBanmian = banmian;
            $scope.data.imgUrl = banmian.JPPATH;
            $scope.data.pdfPath = banmian.PDPATH;
            $scope.data.banmianName = banmian.BM;
            requestData();
        };

        /**
         * [listenDate description]监听时间变化请求不同日期的报纸
         */
        function listenDate() {
            $scope.$watch('status.docPubtime', function(newValue, oldValue, scope) {
                if (newValue && newValue != oldValue) {
                    var params = $state.params;
                    params.docpubtime = $filter('date')(newValue, 'yyyy/MM/dd HH:mm:ss');
                    $state.go($state.current.name, params, { reload: true });
                }
            });
        }

        /**
         * [initOperFlag description] 初始化取签见撤重
         */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.items, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds,
                };
                params = angular.extend(params, $scope.basicParams);
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
            $scope.data.selectedArray = [];
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }
        // 取签见撤重 点击弹出

        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        };

        /**
         * [selectAll description:全选]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc 单选]
         * @param  {[type]} item [description：单个对象]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [openTakeDraftModal description]取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'fetch',
                guid: $scope.status.isShowDetail
                    ? $scope.data.currItem.ZB_GUID
                    : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
            };
            params = angular.extend(params, $scope.basicParams);
            // var isOnlyOne = !($scope.data.selectedArray.length > 1);
            var modalInstance = resCtrModalService.fullTakeDraft(params, true);
            modalInstance.result.then(
                function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        initOperFlag();
                    });
                },
                function() {
                    initOperFlag();
                }
            );
        };

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
         * [getDirectEditParams description] 组装直接编辑参数
         * @param  {[type]} data   [description]    保存成功稿件后返回的数据
         * @param  {[type]} result [description]    由弹窗返回的数据
         * @return {[type]}        [description]
         */
        function getDirectEditParams(data, result) {
            $scope.data.directiveEditParams.chnldocid = data.REPORTS[0].CHNLDOCID;
            $scope.data.directiveEditParams.metadataid = data.REPORTS[0].METADATAID;
            var params = {
                serviceid: 'mlf_paperset',
                methodname: 'findPaperById',
                SiteId: result.siteid,
            };
            var deferred = $q.defer();
            if (!!result.siteid) {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                    $scope.data.directiveEditParams.siteid = result.siteid;
                    $scope.data.directiveEditParams.paperid = result.siteid;
                    $scope.data.directiveEditParams.channelid = result.Web;
                    $scope.data.directiveEditParams.metadata = data.REPORTS[0].METADATAID;
                    $scope.data.directiveEditParams.newspapertype = data.ISDUOJISHEN == '0' ? 2 : 1;
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        /**
         * [getDirectEditRouter description]组装取稿时直接编辑的路由
         * @param  {[type]} result [description] 弹窗返回数据
         */
        function getDirectEditRouter(result) {
            if (Boolean(result.ToMy)) {
                $scope.data.directiveEditParams.belongedType = 'iwoEdit';
                return $scope.status.iwoEdit[result.items[0].doctype];
            } else if (Boolean(result.Paper)) {
                $scope.data.directiveEditParams.belongedType = 'newspaperEdit';
                return $scope.status.newspaperEdit[result.items[0].doctype];
            } else if (Boolean(result.Web)) {
                $scope.data.directiveEditParams.belongedType = 'websiteEdit';
                return $scope.status.websiteEdit[result.items[0].doctype];
            }
        }

        /**
         * [CreationAxis description]加入创作轴
         */
        $scope.CreationAxis = function() {
            var params = angular.copy($scope.basicParams);
            params.guid = $scope.status.isShowDetail
                ? $scope.data.currItem.ZB_GUID
                : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',');
            resourceCenterService.setBigDataCreation(params).then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
                $scope.data.selectedArray = [];
            });
        };

        /**
         * [printbtn description]打印
         */
        $scope.printbtn = function() {
            var params = {
                serviceid: $scope.status.currModule,
                modelid: 'detailData',
                guid: $scope.status.isShowDetail
                    ? $scope.data.currItem.ZB_GUID
                    : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                channelName: $scope.basicParams.channelName,
                typeid: 'zyzx',
                indexName: $scope.basicParams.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                trsPrintService.trsPrintBigData(data);
            });
        };
        // 预留
        $scope.openReserveDraftModal = function() {
            var selectedArray = $scope.status.isShowDetail ? [$scope.data.currItem] : $scope.data.selectedArray;
            var resCtrModalServiceModal = resCtrModalService.reserveDraft(selectedArray);
            resCtrModalServiceModal.result.then(function(result) {
                delete result.items;
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'delay',
                    guid: $scope.status.isShowDetail
                        ? $scope.data.currItem.ZB_GUID
                        : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                };
                params = angular.extend(params, $scope.basicParams);
                params = angular.extend(params, result);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function() {
                            initOperFlag();
                        });
                    },
                    function() {
                        initOperFlag();
                    }
                );
            });
        };

        // 收藏
        $scope.collect = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: $scope.status.isShowDetail
                    ? $scope.data.currItem.ZB_GUID
                    : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
            };
            params = angular.extend(params, $scope.basicParams);
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, '');
            });
        };

        /** 导出 */
        $scope.export = function() {
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportBigDataDocs',
                GUIDS: $scope.status.isShowDetail
                    ? $scope.data.currItem.ZB_GUID
                    : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                CHANNELNAMES: $scope.basicParams.channelName,
                indexName: $scope.basicParams.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
            });
        };

        /** ********************************canvas开始**************************************/
        var canvascheck = document.createElement('canvas');
        var isIE = window.navigator.systemLanguage ? 1 : 0;
        var isVM = document.namespaces ? 1 : 0;
        var isJG = 0;
        var isCV = canvascheck.getContext ? 1 : 0;
        var jg = [];

        if (isVM) {
            if (document.namespaces['v'] == null) {
                var stl = document.createStyleSheet();
                // stl.addRule("v\\:*", "behavior: url(#default#VML); antialias: true;");

                document.namespaces.add('v', 'urn:schemas-microsoft-com:vml');
            }
        }

        function fadeCanvas(id, opac) {
            var obj = document.getElementById(id);
            if (opac <= 100) {
                obj.style.opacity = opac / 100;
                opac += 10;
                window.setTimeout(fadeCanvas(id, opac), 10);
            }
        }

        function CoordMax(coord, w, h, realW, realH) {
            // 新宽度
            if (!w) {
                w = 300;
            }
            // 新高度
            if (!h) {
                h = 477;
            }
            var arrays = coord.split(',');
            var cd;
            var newCoord = arrays
                .map(function(v, k) {
                    if (k % 2 == 0) {
                        cd = (v / realW) * w;
                    } else {
                        cd = (v / realH) * h;
                    }
                    return parseInt(cd);
                }, this)
                .toString();
            return newCoord;
        }

        function setAreaOver(obj, id, b, c, o, n, f, z) {
            var i,
                j,
                x,
                y,
                context,
                p = '',
                canvas = document.getElementById(id);
            var v = obj.coords.split(',');
            if (isVM) {
                if (obj.shape.toLowerCase() == 'rect') {
                    canvas.innerHTML =
                        '<v:rect strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" style="zoom:1;margin:0;padding:0;display:block;position:absolute;left:' +
                        parseInt(v[0]) +
                        'px;top:' +
                        parseInt(v[1]) +
                        'px;width:' +
                        parseInt(v[2] - v[0]) +
                        'px;height:' +
                        parseInt(v[3] - v[1]) +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:rect>';
                } else if (obj.shape.toLowerCase() == 'circle') {
                    canvas.innerHTML =
                        '<v:oval strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" style="zoom:1;margin:0;padding:0;display:block;position:absolute;left:' +
                        parseInt(v[0] - v[2]) +
                        'px;top:' +
                        parseInt(v[1] - v[2]) +
                        'px;width:' +
                        parseInt(v[2]) * 2 +
                        'px;height:' +
                        parseInt(v[2]) * 2 +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:oval>';
                } else {
                    for (j = 2; j < v.length; j += 2) {
                        p += parseInt(v[j]) + ',' + parseInt(v[j + 1]) + ',';
                    }
                    canvas.innerHTML =
                        '<v:shape strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" coordorigin="0,0" coordsize="' +
                        canvas.width +
                        ',' +
                        canvas.height +
                        '" path="m ' +
                        parseInt(v[0]) +
                        ',' +
                        parseInt(v[1]) +
                        ' l ' +
                        p +
                        ' x e" style="zoom:1;margin:0;padding:0;display:block;position:absolute;top:0px;left:0px;width:' +
                        canvas.width +
                        'px;height:' +
                        canvas.height +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:shape>';
                }
            } else if (isCV) {
                if (f < 1) {
                    canvas.style.opacity = 0;
                }
                context = canvas.getContext('2d');
                context.beginPath();
                context.lineWidth = '1';
                if (obj.shape.toLowerCase() == 'rect') {
                    context.rect(0.5 + parseInt(v[0]), 0.5 + parseInt(v[1]), parseInt(v[2] - v[0]), parseInt(v[3] - v[1]));
                    context.closePath();
                } else if (obj.shape.toLowerCase() == 'circle') {
                    context.arc(0.5 + parseInt(v[0]), 0.5 + parseInt(v[1]), parseInt(v[2]), 0, (Math.PI / 180) * 360, false);
                } else {
                    context.moveTo(parseInt(v[0]), parseInt(v[1]));
                    for (j = 2; j < v.length; j += 2) {
                        context.lineTo(parseInt(v[j]), parseInt(v[j + 1]));
                    }
                    context.closePath();
                }
                context.fillStyle = 'rgba(' + c + ',' + o + ')';
                context.strokeStyle = 'rgba(' + b + ',0)'; // 边框线暂时为透明
                context.fill();
                if (n < 1) {
                    context.stroke();
                }
                if (f < 1) {
                    fadeCanvas(id, 0);
                }
            } else {
                jg[z].setColor('#' + c);
                if (obj.shape.toLowerCase() == 'rect') {
                    jg[z].fillRect(parseInt(v[0]), parseInt(v[1]), parseInt(v[2] - v[0]) + 1, parseInt(v[3] - v[1]) + 1);
                } else if (obj.shape.toLowerCase() == 'circle') {
                    jg[z].fillEllipse(parseInt(v[0] - v[2]), parseInt(v[1] - v[2]), parseInt(v[2]) * 2 + 1, parseInt(v[2]) * 2 + 1);
                } else {
                    x = new Array();
                    y = new Array();
                    i = 0;
                    for (j = 0; j < v.length; j += 2) {
                        x[i] = parseInt(v[j]);
                        y[i] = parseInt(v[j + 1]);
                        i++;
                    }
                    jg[z].fillPolygon(x, y);
                }
                jg[z].paint();
            }
        }

        function setAreaOut(obj, id, f, z) {
            var canvas = document.getElementById(id);
            if (isVM) {
                canvas.innerHTML = '';
            } else if (isJG) {
                jg[z].clear();
            } else if (isCV) {
                var context = canvas.getContext('2d');
                context.clearRect(0, 0, canvas.width, canvas.height);
            }
        }

        function init_area(realWidth, realHeight) {
            var canvans_width = $('#Img_a_canvas').attr('width');
            var canvans_height = $('#Img_a_canvas').attr('height');
            $('#js_tbody')
                .find('a')
                .each(function() {
                    $(this).attr('coords', CoordMax($(this).attr('coords'), canvans_width, canvans_height, realWidth, realHeight));
                });
            $('.forArchives')
                .find('area')
                .each(function() {
                    var $this = $(this);
                    $this.attr('coords', CoordMax($this.attr('coords'), canvans_width, canvans_height, realWidth, realHeight)); // 转变坐标为map区域 坐标
                    var $x = -70;
                    var $y = -80;
                    $this
                        .mouseover(function(e) {
                            if ($('.mapDiv').length > 0) {
                                return;
                            }
                            // var name = $(this).attr("alt") == "无标题" ? '' : $(this).attr("alt");
                            var name = $(this).attr('alt');
                            var index_num = $(this).index();
                            var mapClass = name != '无标题' ? 'mapDiv' : 'mapDiv hide';
                            var dom = "<div class='" + mapClass + "'><span class='name'></span></div>";
                            $('.resouCen-digitalDetail').append(dom);
                            $('.name').text(name);
                            $('.mapDiv')
                                .css({
                                    top: e.pageY + $y + 'px',
                                    left: e.pageX + $x + 'px',
                                })
                                .show('fast');
                        })
                        .mouseout(function() {
                            $('.mapDiv').remove();
                        })
                        .mousemove(function(e) {
                            $('.mapDiv').css({
                                top: e.pageY + $y + 'px',
                                left: e.pageX + $x + 'px',
                            });
                        });
                });
        }
        // 初始化canvas
        function initCanvas() {
            $('.forArchives').delegate('.newsPaper', 'mouseover mouseout', function(event) {
                if (event.type == 'mouseover') {
                    setAreaOver(this, 'Img_a_canvas', '39,84,128', '255,190,92', '0.35', 0, 0, 0);
                } else if (event.type == 'mouseout') {
                    setAreaOut(this, 'Img_a_canvas', 0, 0);
                }
            });
        }

        /** ********************************canvas结束**************************************/
        /**
         * [checkDetail description]查看稿件详情
         */
        $scope.checkDetail = function(item, index) {
            var params = {
                serviceid: $scope.basicParams.channelName,
                modelid: 'detailData',
                guid: item.ZB_GUID,
                channelName: $scope.basicParams.channelName,
                typeid: 'zyzx',
                indexName: $scope.basicParams.indexName,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.detail = data.content[0];
                $scope.basicParams.indexName = data.summary_info.indexName;
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\r\n/g, '<br/>');
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\r/g, '<br/>');
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\n/g, '<br/>');
                $scope.data.detail.CONTENT = dealContent($scope.data.detail.CONTENT);
                // $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/<img/g, '<img style="max-width:512px;"');
                $scope.status.isShowDetail = true;
                $scope.data.currItem = item;
                $scope.data.currIndex = index;
            });
        };

        /**
         * [returnToList description]返回稿件列表页
         */
        $scope.returnToList = function() {
            if (!$scope.status.isShowDetail) {
                return;
            }
            $scope.status.isShowDetail = false;
            $scope.data.detail = '';
        };

        /**
         * [jumpToDraft description]上一篇/下一篇
         */
        $scope.jumpToDraft = function(isNext) {
            if (
                (!isNext && $scope.data.currIndex == 0) ||
                (isNext && $scope.data.currIndex == $scope.data.items.length - 1) ||
                !$scope.status.isShowDetail
            ) {
                return;
            }
            var index = isNext ? $scope.data.currIndex + 1 : $scope.data.currIndex - 1;
            var params = {
                serviceid: $scope.basicParams.channelName,
                modelid: 'detailData',
                guid: $scope.data.items[index].ZB_GUID,
                channelName: $scope.basicParams.channelName,
                typeid: 'zyzx',
                indexName: $scope.basicParams.indexName,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.detail = data.content[0];
                $scope.basicParams.indexName = data.summary_info.indexName;
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\r\n/g, '<br/>');
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\r/g, '<br/>');
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\n/g, '<br/>');
                if ($scope.data.detail.CONTENT) {
                    $scope.data.detail.CONTENT = dealContent($scope.data.detail.CONTENT);
                }
                $scope.status.isShowDetail = true;
                $scope.data.currItem = $scope.data.items[index];
                $scope.data.currIndex = index;
            });
        };

        /**
         * [jumpToBanmian description]上一版/下一版
         */
        $scope.jumpToBanmian = function(isNext) {
            var originalIndex = $scope.data.dropDown.banciList.indexOf($scope.data.dropDown.selectedBanmian),
                index = isNext ? originalIndex + 1 : originalIndex - 1;
            if ((!isNext && originalIndex == 0) || (isNext && originalIndex == $scope.data.dropDown.banciList.length - 1)) {
                return;
            }
            $scope.data.dropDown.selectedBanmian = $scope.data.dropDown.banciList[index];
            $scope.params.bc = $scope.data.dropDown.banciList[index].BC;
            $scope.data.imgUrl = $scope.data.dropDown.banciList[index].JPPATH;
            $scope.data.pdfPath = $scope.data.dropDown.banciList[index].PDPATH;
            $scope.data.banmianName = $scope.data.dropDown.banciList[index].BM;
            requestData();
        };

        /**
         * [jumpToPhase description] 上一期/下一期
         * @param  {Boolean} isNext [description]
         * @return {[type]}         [description]
         */
        $scope.jumpToPhase = function(isNext) {
            var params = $state.params;
            if ($scope.status.hasNext && isNext) {
                params.docpubtime = $scope.status.hasNext;
            } else if ($scope.status.hasPrev && !isNext) {
                params.docpubtime = $scope.status.hasPrev;
            } else {
                return;
            }
            $state.go($state.current.name, params, { reload: true });
        };

        /**
         * [findOtherTermsPubtime description]
         * @return {[type]} [description]
         */
        function findOtherTermsPubtime() {
            var params = {
                typeid: 'zyzx',
                serviceid: 'szb',
                modelid: 'findOtherTermsPubtime',
                docpubtime: $scope.status.docPubtime,
                mediaId: $stateParams.nodeid,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.status.hasNext = data.content[0].aftTermTime;
                $scope.status.hasPrev = data.content[0].befTermTime;
            });
        }

        /**
         * [download description] 下载
         * @return {[type]} [description]
         */
        $scope.download = function() {
            window.open($scope.data.pdfPath);
        };

        /**
         * [dealContent description]处理详情内容的格式
         */
        function dealContent(content) {
            return ueditorService
                .replaceHtmlBlank(content)
                .replace(/(<(?:p|div)[^>]*>(?:<(?:span|b)[^>]*>)*)(?:&nbsp;| |　)*/gi, '$1　　')
                .replace(/(<br[^>]*>)(?:&nbsp;| |　)*/gi, '$1　　')
                .replace(/>　　</g, '><')
                .replace(/style="[^>]*"/g, '');
        }

        // 获取头像
        function headPortrait() {
            // detail
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }
        $rootScope.$on('updateHeadPortrait', function(event, data) {
            headPortrait();
        });
    },
]);
